﻿import { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useCompanies } from '@/hooks/useCompanies';
import { useAuth } from '@/context/AuthContext';

interface Props {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export default function CompanySelect({ value, onChange, className }: Props) {
  const { t } = useTranslation();
  const { companies, fetchCompanies } = useCompanies();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) fetchCompanies();
  }, [isAuthenticated, fetchCompanies]);

  return (
    <Form.Select value={value} onChange={e => onChange(e.target.value)} className={className}>
      <option value="0">{t('selectCompany')}</option>
      {companies.map(c => (
        <option key={c.codice} value={c.codice}>{c.descrizione}</option>
      ))}
    </Form.Select>
  );
}
